import React, { useMemo, useState } from 'react'
import { Link } from 'react-router-dom'
import './ToolsIndex.css'
import { trackEvent } from '../../lib/analytics'
import { useDocumentMeta } from '../../hooks/useDocumentMeta'
import { CATEGORIES, TOOLS } from './toolsData'

const ToolsIndex = () => {
  useDocumentMeta({
    title: 'Ferramentas Gratuitas Online | jarder.dev',
    description:
      'Gerador de CPF/CNPJ, senha, QR Code, conversores, calculadoras e ' +
      'mais: mais de 40 ferramentas rápidas e gratuitas, sem cadastro, ' +
      'direto no navegador.',
  })

  const [activeCategory, setActiveCategory] = useState('todas')
  const [search, setSearch] = useState('')

  const countByCategory = useMemo(() => {
    const counts = {}
    TOOLS.forEach((tool) => {
      counts[tool.category] = (counts[tool.category] || 0) + 1
    })
    return counts
  }, [])

  const filteredTools = useMemo(() => {
    const query = search.trim().toLowerCase()
    return TOOLS.filter((tool) => {
      const matchesCategory =
        activeCategory === 'todas' || tool.category === activeCategory
      const matchesSearch =
        !query ||
        tool.title.toLowerCase().includes(query) ||
        tool.description.toLowerCase().includes(query)
      return matchesCategory && matchesSearch
    })
  }, [activeCategory, search])

  const selectCategory = (key) => {
    setActiveCategory(key)
    trackEvent('tool_category_filter', { category: key })
  }

  return (
    <div className="tools-index">
      <h1>Ferramentas gratuitas</h1>
      <p className="tools-index-subtitle">
        Utilitários rápidos, sem cadastro, direto no navegador.
      </p>

      <div className="tools-search-wrap">
        <input
          type="text"
          className="tools-search-input"
          placeholder="buscar ferramenta..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
      </div>

      <div className="tools-category-filters">
        <button
          type="button"
          className={`tools-category-chip${activeCategory === 'todas' ? ' active' : ''}`}
          onClick={() => selectCategory('todas')}
        >
          Todas ({TOOLS.length})
        </button>
        {CATEGORIES.map((cat) => (
          <button
            key={cat.key}
            type="button"
            className={`tools-category-chip${activeCategory === cat.key ? ' active' : ''}`}
            onClick={() => selectCategory(cat.key)}
          >
            <cat.icon className="tools-category-chip-icon" aria-hidden="true" />
            {cat.label} ({countByCategory[cat.key] || 0})
          </button>
        ))}
      </div>

      {filteredTools.length === 0 ? (
        <p className="tools-empty-state">
          Nenhuma ferramenta encontrada. Tente outra busca ou categoria.
        </p>
      ) : (
        <div className="tools-grid">
          {filteredTools.map((tool) => (
            <Link
              to={tool.to}
              className="tool-card"
              key={tool.to}
              onClick={() =>
                trackEvent('tool_card_click', { tool: tool.title })
              }
            >
              <span className="tool-card-icon">
                <tool.icon aria-hidden="true" />
              </span>
              <h2>{tool.title}</h2>
              <p>{tool.description}</p>
            </Link>
          ))}
        </div>
      )}
    </div>
  )
}

export default ToolsIndex
